// extracted by mini-css-extract-plugin
module.exports = {"loadingElement":"Map_loadingElement__2j8q7","container":"Map_container__3xh_q","map":"Map_map__2bGnQ"};